export default "__VITE_ASSET__FDqoHgmP__"